import { gql } from '@apollo/client';

export const CREATE_PICKUP_ROUTE_HISTORY = gql`
  mutation CreatePickupRouteHistory($input: CreatePickupRouteHistoryInput!) {
    createPickupRouteHistory(input: $input) {
      id
      warehouseId
      pickupDate
      routeId
      algTaskId
      version
      status
      inputContent
      resultContent
      maxPollingCount
      currentPollingCount
      pollingFailureReason
      createdAt
      updatedAt
    }
  }
`;
